import React from 'react';
import { useNavigate } from 'react-router-dom';

const SOMMELIER_AVATAR = "https://customer-assets.emergentagent.com/job_wine-sommelier-2/artifacts/vu5iglcz_att.ynPmhaFhSeLs5blyB0W6yY3b31D9r_dMDQ9FnJVxofo.jpeg";

const SelectRestaurant = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-3 flex justify-center">
          <div className="flex flex-col items-center leading-none">
            <span className="text-[10px] font-medium tracking-[0.3em] text-gray-400">THE</span>
            <span className="text-lg font-semibold tracking-wide" style={{fontFamily: 'Georgia, serif', color: '#722F37'}}>SOMM</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-8">
        <div className="max-w-md w-full">
          {/* Sommelier Avatar */}
          <div className="flex justify-center mb-6">
            <img 
              src={SOMMELIER_AVATAR}
              alt="Your Sommelier"
              className="h-20 w-20 rounded-full object-cover"
            />
          </div>

          <h1 className="text-xl font-medium text-gray-900 mb-6 text-center" style={{fontFamily: 'Georgia, serif'}}>
            Select Your Restaurant
          </h1>

          {/* Restaurant Cards */}
          <div className="space-y-4">
            {/* Treadwell Card */}
            <button
              onClick={() => navigate('/treadwell')}
              className="w-full bg-white rounded-2xl p-5 text-left hover:border-[#D4704A] border border-gray-100 transition-all duration-200 flex items-center gap-4"
            >
              <img 
                src="/treadwell-logo.png" 
                alt="Treadwell" 
                className="h-14 w-14 object-contain rounded-lg"
              />
              <div className="flex-1">
                <h2 className="text-lg font-medium text-gray-900" style={{fontFamily: 'Georgia, serif'}}>
                  Treadwell Cuisine
                </h2>
                <p className="text-xs text-gray-500">500+ wines available</p>
              </div>
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>

            {/* NOTL Card */}
            <button
              onClick={() => navigate('/notl')}
              className="w-full bg-white rounded-2xl p-5 text-left hover:border-[#2C3E50] border border-gray-100 transition-all duration-200 flex items-center gap-4"
            >
              <img 
                src="/notl-logo.jpg" 
                alt="NOTL" 
                className="h-14 w-14 object-contain rounded-lg"
              />
              <div className="flex-1">
                <h2 className="text-lg font-medium text-gray-900" style={{fontFamily: 'Georgia, serif'}}>
                  NOTL
                </h2>
              </div>
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Info Note */}
          <p className="text-xs text-gray-400 text-center mt-6 px-4">
            Wines from Treadwell's cellar can be ordered at NOTL
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelectRestaurant;
